export default __webpack_public_path__ + "static/arvo-latin-700-normal-891ffc5dbfebe7828ea857dc6fe8b106.woff2";